module.exports = "pegasus/assets/theme6/medium/8.jpg";